module.exports = __webpack_public_path__ + "static/media/screen4.bae5841c.png";